import { ComuneDTO } from "./comune.model";
import { Coordinate } from "./coordinate.model";
import { Edificio } from "./edificio.model";
import { Sostegno } from "./sostegno.models";
import { StatoSegnalazione } from "./stato.segnalazione.model";
import { TipoSegnalazione } from "./tipoSegnalazione.model";
import { Utente } from "./utente.model";

export class Segnalazione {
    id: number;
    codice: string;
    priorita: string;

    autore:Utente;
    operatoreInCarico:Utente;

    segnalatore:string;
    descrizione:string;
    noteChiusura:string;
    noteRifiuto:string;

    indirizzo?:string;
    // sostegno:Sostegno;
    sostegni?: Sostegno[];
    coordinate?:Coordinate;
    isCoordinateCalculated?: boolean;

    comune:ComuneDTO;

    creata:Date;
    modificata:Date;

    stato:StatoSegnalazione;
    tipoSegnalazione:TipoSegnalazione;

    allegato:boolean;

    edifici?: Edificio[];
  }
